import { useAccrualPolicyRepository } from '../repositories';

export function useAccrualPolicies(variables?: { page?: number; perPage?: number }) {
  const repo = useAccrualPolicyRepository();
  return repo.useList(variables);
}

export function useCreateAccrualPolicy() {
  const repo = useAccrualPolicyRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

export function useUpdateAccrualPolicy() {
  const repo = useAccrualPolicyRepository();
  const { update, loading, error } = repo.useUpdate();
  return {
    mutate: (vars: { id: string; input: any }) => update(vars.id, vars.input),
    mutateAsync: (vars: { id: string; input: any }) => update(vars.id, vars.input),
    isPending: loading,
    loading,
    error,
  };
}

export function useDeleteAccrualPolicy() {
  const repo = useAccrualPolicyRepository();
  const result = repo.useDelete();
  return {
    mutate: (vars: { id: string }) => result.delete(vars.id),
    mutateAsync: (vars: { id: string }) => result.delete(vars.id),
    isPending: result.loading,
    loading: result.loading,
    error: result.error,
  };
}
